import { useTranslation } from "@nova/use-translation"
import { trimMiddle } from "@nova/util-strings"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { ProfilePhoto } from "../profile/ProfilePhoto"

type WorkspaceCollaboratorProfileProps = {
    fullName?: string
    userId?: string
    email?: string
    trimEmail?: boolean
    isFullWidth?: boolean
    isAlreadyAdded?: boolean
}
export const WorkspaceCollaboratorProfile = ({
    fullName,
    userId,
    email,
    trimEmail,
    isFullWidth,
    isAlreadyAdded,
}: WorkspaceCollaboratorProfileProps) => {
    const { t } = useTranslation()

    const isPending = !fullName
    let memberEmail = isPending ? userId : email
    if (trimEmail && memberEmail)
        memberEmail = trimMiddle(memberEmail, { maxLength: 25, distribution: 0 })

    return (
        <div
            className={classNames("flex items-center gap-4 text-left", {
                "w-full": isFullWidth,
            })}
        >
            {userId && fullName && (
                <div className="w-8 min-w-[32px] aspect-square rounded-lg overflow-hidden">
                    <ProfilePhoto userId={userId} fullName={fullName || ""} />
                </div>
            )}
            {!userId && (
                <div className="h-8 w-8 border-white-400 border flex items-center justify-center rounded-xl">
                    <Icons.Icon Icon={Icons.NoAccount} className="text-white-400 relative" />
                </div>
            )}
            {fullName && (
                <div className="shrink min-w-0 truncate text-gray-200">
                    {/* Gross coupling in the styles, but this component is used in a bunch of places, and we want to underline the name if this is wrapped in a UserProfileModalTrigger */}
                    <h5 className="text-gray-0 group-hover/UserProfileModalTrigger:underline truncate">
                        {t(fullName)}
                    </h5>
                    {memberEmail && (
                        <small className="block truncate text-gray-200 lowercase">
                            {t(memberEmail)}
                        </small>
                    )}
                </div>
            )}
            {!fullName && (
                <div className="shrink min-w-0 truncate text-gray-200">
                    <h5 className="text-orange-500">{t("Access Pending")}</h5>
                    {memberEmail && (
                        <small className="block truncate text-gray-200 lowercase">
                            {t(memberEmail)}
                        </small>
                    )}
                </div>
            )}
            {isAlreadyAdded && (
                <>
                    <div className="grow" />
                    <small className="text-gray-300 shrink-0">Already added</small>
                </>
            )}
        </div>
    )
}
